import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import withTranslation from '../../../../../hoc/withTranslation';
import ModuleService from '../../../../../services/module';
import { List, ListItem } from 'material-ui/List';
import styles from '../FirebaseModuleBlock/FirebaseModuleBlock.css';
import Error from 'material-ui/svg-icons/alert/error';
import { white } from 'material-ui/styles/colors';

class KeycloakModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        let content = null;
        if (
            this.props.app.configurations.keycloak_issuer === ''
            || this.props.app.configurations.keycloak_audience === ''
            || this.props.app.configurations.keycloak_jwks_uri === ''
        ) {
            content = <List>
                <ListItem
                    style={styles.list}
                    disabled={true}
                    primaryText={this.props.t('module.keycloak.configuration_ko')}
                    leftIcon={<Error color={white} />}
                />
            </List>;
        }
        return (
            <ModuleBlock
                app={this.props.app}
                module={ModuleService.getModule(ModuleService.KEYCLOAK)}
                content={content}
            />
        );
    }
}

export default withTranslation(KeycloakModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/KeycloakModuleBlock/KeycloakModuleBlock.js